import { Country } from "./../../../entities/shared/Country";
import { LocalStorageService } from "./../../../services/shared/local-storage/local-storage.service";
import { IAbmBuscador, IColumnsTable, ITableSearchConfig } from "./../../../interfaces/pages/abm/abm-buscador.interface";
import { EnumAbmBuscadorFlow } from "./../../../enums/shared/abm-buscador-enum";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { EfxClientPagedDataSource } from "@signal/component-library/efx-data-table";
import { AbmColumnsMantenedorBuscador, AbmColumnsStructConfig } from "src/app/entities/shared/Abm-buscador";
import { EfxPagerComponent } from "@signal/component-library/efx-pager";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import { SignalDesignModule } from "src/app/signal-design/signal-design.module";
import { FormsModule } from "@angular/forms";
import { UnderscoreWrapPipe } from "src/app/pipes/underscore-wrap.pipe";

@Component({
    selector: "app-tabla-dinamica-buscador",
    templateUrl: "./tabla-dinamica-buscador.component.html",
    styleUrls: ["./tabla-dinamica-buscador.component.scss"],
    standalone: true,
    imports: [CommonModule, MatTableModule, SignalDesignModule, FormsModule, UnderscoreWrapPipe]
})
export class TablaDinamicaBuscadorComponent {

  private readonly pathSeparator = ' > ';

  @Input() set inDataValues(values) {
    if (!!values) {
      this._dataValue = values;
      this.initDataSource();
    }
  }

  emitUpdate() {
    console.log("Emitiendo data actualizada desde el hijo:", this._dataValue);
    this.setTabletAbm.emit(this._dataValue);
  }

  @Input() set inStructField(struc: ITableSearchConfig[]) {
    !!struc ? this.getDynamicColumns(struc) : this.getColumnTable();
  }

  @Input() set inFlowTable(flowTable: EnumAbmBuscadorFlow) {
    this.flowTable = flowTable;
    this.getColumnTable();
  }

  @Output() onConfigButton: EventEmitter<IAbmBuscador> = new EventEmitter<IAbmBuscador>();
  @Output() onDeletedButton: EventEmitter<IAbmBuscador> = new EventEmitter<IAbmBuscador>();
  @Output() onEditButton: EventEmitter<IAbmBuscador> = new EventEmitter<IAbmBuscador>();
  @Output() onViewButton: EventEmitter<IAbmBuscador> = new EventEmitter<IAbmBuscador>();
  @Output() onClickRow: EventEmitter<IAbmBuscador> = new EventEmitter<IAbmBuscador>();
  @Output() setTabletAbm: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(EfxPagerComponent) paginator: EfxPagerComponent;

  private _dataValue;
  columnsTable: IColumnsTable[];
  columnsTableMaterial: string[] = [];
  dataSource: EfxClientPagedDataSource;
  dataSourceMaterial: MatTableDataSource<any[]>;
  flowTable: EnumAbmBuscadorFlow;
  pageSizeTable: number;

  get OptionFlowTable(): typeof EnumAbmBuscadorFlow {
    return EnumAbmBuscadorFlow;
  }

  get regionSeleccionada(): Country {
    return this.localStorageService.getRegionSeleccionada;
  }

  constructor(private localStorageService: LocalStorageService) {
    this.pagerSizeFromFrame();
    this.dataSource = new EfxPagedAndSortingDataSource();
  }

  pagerSizeFromFrame() {
    const windowWidth = window.innerHeight;
    if (windowWidth > 1000) this.pageSizeTable = 10;
    else this.pageSizeTable = 5;
  }

  initDataSource() {
    this.dataSource.setData(this._dataValue);
    this.dataSource.refresh();
    this.dataSourceMaterial = new MatTableDataSource(this._dataValue);
  }

  getColumnTable() {
    this.columnsTable = [];
    switch (this.flowTable) {
      case EnumAbmBuscadorFlow.Mantenedor:
        this.columnsTable = AbmColumnsMantenedorBuscador;
        break;
      case EnumAbmBuscadorFlow.Configuracion:
        this.columnsTable = AbmColumnsStructConfig;
        break;
    }
  }

  getDynamicColumns(struc: ITableSearchConfig[]) {
    const dynamicColumns: IColumnsTable[] = [];
    this.columnsTableMaterial = [];
    struc?.sort((a, b) => (a.order > b.order ? 1 : -1))
      .forEach((struct) => {
        const { varName: field, varLabel: header } = struct;
        dynamicColumns.push({ field, header, isSortable: false });
        this.columnsTableMaterial.push(field);
      });
    this.columnsTable = dynamicColumns;
  }

  newOrderNumber(visible: boolean): number {
    const onlyNumber: any[] = this._dataValue.filter((data) => parseInt(data.order));
    this.setTabletAbm.emit(onlyNumber);
    if (onlyNumber.length) {
      const maxOrder = onlyNumber.reduce(
        (max, dato) => (parseInt(dato.order) > max ? parseInt(dato.order) : max),
        -Infinity
      );
      return visible ? maxOrder + 1 : null;
    } else {
      return visible ? 1 : null;
    }
  }

  onToggleChange(row: any, event: any) {
    row.visible = event?.checked;
    row.order = this.newOrderNumber(row.visible);
    this.emitUpdate();
  }

  // --- LÓGICA NUEVA PARA ACTUALIZAR EL LABEL ---
  onLabelChange(row: any, newValue: string) {
    // 1. Actualizamos el valor en la fila actual
    row.varLabel = newValue;
    // 2. Emitimos la actualización completa del array al padre
    this.emitUpdate();
  }

  getPathLeaf(path: string): string {
    const normalizedPath = String(path || '').trim();
    if (!normalizedPath) {
      return '';
    }

    const lastSegment = normalizedPath.split('.').pop() || normalizedPath;
    return lastSegment.replace(/\[\]/g, '');
  }

  getPathContext(path: string): string {
    const normalizedPath = String(path || '').trim();
    if (!normalizedPath || normalizedPath.indexOf('.') === -1) {
      return '';
    }

    const segments = normalizedPath.split('.');
    segments.pop();
    return segments.join(this.pathSeparator);
  }

  hasNestedPath(path: string): boolean {
    return String(path || '').indexOf('.') !== -1 || String(path || '').indexOf('[]') !== -1;
  }

  hasArrayPath(path: string): boolean {
    return String(path || '').indexOf('[]') !== -1;
  }

  isMantenedorEmptyCell(flow: EnumAbmBuscadorFlow, row: any, field: string, value: unknown): boolean {
    if (flow !== EnumAbmBuscadorFlow.Mantenedor) {
      return false;
    }

    if (field !== 'domain' && field !== 'subDomain') {
      return false;
    }

    // En PURPOSING, subDomain puede venir vacío y mostrarse desde purposingProfile como texto plano.
    if (field === 'subDomain' && String(row?.searchSourceType || '').toUpperCase() === 'PURPOSING') {
      const purposingProfile = row?.purposingProfile;
      if (!this.isEmptyValue(purposingProfile)) {
        return false;
      }
    }

    return this.isEmptyValue(value);
  }

  getCellDisplayValue(row: any, field: string): string {
    if (field === 'subDomain' && String(row?.searchSourceType || '').toUpperCase() === 'PURPOSING') {
      const profile = String(row?.purposingProfile || '').trim();
      if (profile) {
        return profile;
      }
    }

    return row?.[field];
  }

  getMantenedorEmptyLabel(row: any, field: string): string {
    const domainEmpty = this.isEmptyValue(row?.domain);
    const subDomainEmpty = this.isEmptyValue(row?.subDomain);

    if (field === 'domain' && domainEmpty && subDomainEmpty) {
      return 'PROPOSITO';
    }

    if (field === 'domain') {
      return 'SIN DOMINIO';
    }

    return 'SIN SUB DOMINIO';
  }

  getMantenedorEmptyBadgeClass(row: any, field: string): string {
    if (this.hasPurposingDerivedValue(row, field)) {
      return 'is-purpose-derived';
    }

    return this.getMantenedorEmptyLabel(row, field) === 'PROPOSITO' ? 'is-purpose' : 'is-empty';
  }

  getMantenedorEmptyIcon(row: any, field: string): string {
    return this.getMantenedorEmptyBadgeClass(row, field).indexOf('is-purpose') !== -1 ? 'hub' : '';
  }

  private isEmptyValue(value: unknown): boolean {
    return value === null || value === undefined || String(value).trim() === '';
  }

  private hasPurposingDerivedValue(row: any, field: string): boolean {
    return field === 'subDomain'
      && String(row?.searchSourceType || '').toUpperCase() === 'PURPOSING'
      && !this.isEmptyValue(row?.purposingProfile);
  }
}

// ... (La clase EfxPagedAndSortingDataSource se mantiene igual)
export class EfxPagedAndSortingDataSource extends EfxClientPagedDataSource {
  // ... tu código existente de ordenamiento
  sortingField: string | undefined = "";
  sortingDirection: string | undefined = "asc";
  override query() {
    if (this.cache) {
      this.cache = this.sortTheCache(this.cache);
    }
    super.query();
  }

  sortTheCache(data: any[]): any[] {
    const newData = [...data];
    Object.keys(this.currentSort).forEach((fieldName: string, index) => {
      this.sortingField = fieldName;
      this.sortingDirection = this.currentSort[fieldName];
    });
    if (this.sortingField && this.sortingDirection) {
      newData.sort(this.compareFn.bind(this));
    }
    return newData;
  }

  compareFn(a: any, b: any) {
    if (this.sortingField) {
      if (a[this.sortingField] === null) {
        return 1;
      }
      if (b[this.sortingField] === null) {
        return -1;
      }
      if (a[this.sortingField] < b[this.sortingField]) {
        return this.sortingDirection === "asc" ? -1 : 1;
      }
      if (a[this.sortingField] > b[this.sortingField]) {
        return this.sortingDirection === "asc" ? 1 : -1;
      }
    }
    return 0;
  }
}